import React, { useCallback, useEffect } from "react";
import { Container, TableContainer, Button, Paper } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import {
  deleteIndicator,
  getIndicators,
  updateIndicatorStatus,
} from "../../services/indicatorServices";
import IndicatorStatus from "./IndicatorStatus";

export default function IndicatorList({
  id,
  indicators,
  showButtons,
  onHandleEdit,
  setIndicators,
  showUpdateStatus,
  setAgreementStatus,
  onlyShow = false,
}) {
  const handleEdit = (indicator) => {
    onHandleEdit(indicator);
  };

  const indicatorsList = useCallback(async () => {
    try {
      const response = await getIndicators(id);
      if (setIndicators) {
        setIndicators(response.data);
      }

      if (setAgreementStatus) {
        setAgreementStatus();
      }
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);

  useEffect(() => {
    if (!onlyShow) {
      indicatorsList();
    }
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await deleteIndicator(id);
      indicatorsList();
      toast.success("El indicador se elimino correctamente");
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        toast.error(err.response.data.error);
      }
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      const response = await updateIndicatorStatus(id, status);
      indicatorsList();
      toast.success("El estado del indicador se actualizó");
    } catch (err) {
      if (!err?.response) {
        
        toast.error("No responde el servidor");
      } else {
        toast.error(err.response.data.error);
      }
    }
  };

  return (
    <Container>
      <h3>Indicadores</h3>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="right">Estado</TableCell>
              <TableCell align="right">Indicador</TableCell>
              <TableCell align="right">Observaciones/Descripciones</TableCell>
              {showButtons && <TableCell align="right">Acciones</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {indicators?.map((indicator) => (
              <TableRow
                key={indicator.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="right">
                  <IndicatorStatus currentStatus={indicator.status} />
                </TableCell>
                <TableCell align="right">{indicator.name}</TableCell>
                <TableCell align="right">{indicator.description}</TableCell>
                {showButtons && (
                  <TableCell align="right">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleEdit(indicator)}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleDelete(indicator.id)}
                    >
                      Eliminar
                    </Button>
                  </TableCell>
                )}
                {showUpdateStatus && indicator.status === "unexecuted" && (
                  <TableCell align="right">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        handleUpdateStatus(indicator.id, "executed")
                      }
                    >
                      Marcar como ejecutado
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
